export default "__VITE_ASSET__DYOna_cK__"